import React from "react";
import useStyles from "../common/Styles";
import { Grid, Typography } from "@material-ui/core";
import { useSelector } from "react-redux";
import { decimalRoundHelper } from "../common/utils";

const MiniMetrics = () => {
    const classes = useStyles();
    const { agriculture_selected, district_water } = useSelector(
        (state) => state.water_user
    );
    const total_water = district_water[agriculture_selected.name].colorado_river +
    district_water[agriculture_selected.name].groundwater +
    district_water[agriculture_selected.name].salt_and_verde +
    district_water[agriculture_selected.name].reclaimed_water +
    district_water[agriculture_selected.name].agua_fria +
    district_water[agriculture_selected.name].santa_cruz +
    district_water[agriculture_selected.name].gila

    const metrics = [
        {
          label: "Colorado River Water",
          value: `${decimalRoundHelper(district_water[agriculture_selected.name].colorado_river / total_water * 100)} %`
        },
        {
          label: "Groundwater",
          value: `${decimalRoundHelper(district_water[agriculture_selected.name].groundwater / total_water * 100)} %`
        },
        {
          label: "Salt & Verde",
          value: `${decimalRoundHelper(district_water[agriculture_selected.name].salt_and_verde / total_water * 100)} %`
        },
        {
          label: "Reclaimed Water",
          value: `${decimalRoundHelper(district_water[agriculture_selected.name].reclaimed_water / total_water * 100)} %`,
        },
        {
          label: "Other Surface Water",
          value: `${decimalRoundHelper((district_water[agriculture_selected.name].agua_fria + district_water[agriculture_selected.name].santa_cruz + district_water[agriculture_selected.name].gila) / total_water * 100)} %`,
        },
    ];
    
    return (
        <Grid item xs={12} className={classes.aboutBox}>
          {metrics.map((metric) => (
            <>
              <Typography
                variant="body2"
                component="p"
                className={classes.metricCaption}
              >
                {metric.label}
              </Typography>
              <Typography
                variant="h6"
                component="div"
                className={classes.metricValue}
              >
                {metric.value}
              </Typography>
            </>
          ))}
        </Grid>
      );
};

export default MiniMetrics;